import './MultiSelectMobileModal.f53e0359d59c6fa8e63c485ca6865bcd.css';
export default {"dialog":"_dialog_y59sl_1"};